module.exports = __webpack_public_path__ + "static/media/stoveOut.18a595c2.gif";